import { createContext, useEffect, useState } from "react";
import { updateShare } from "../../adapters/share-adapter";
import { ShareExpirationOptions } from "../../Constants";

export const ShareLinkContext = createContext();

export const ShareLinkContextProvider = ({ children }) => {
    const [showShareModal, setShowShareModal] = useState(false);
    const [shareCode, setShareCode] = useState();
    const [shareLink, setShareLink] = useState('normili.com');
    const [expirationIndex, setExpirationIndex] = useState(0); // refers to 7 days default value
    const [isContentReady, setIsContentReady] = useState(false);
    const [sharerName, setSharerName] = useState('');

    const [isSelectionModeOn, setSelectionMode] = useState(false);
    const [storySelection, setStorySelection] = useState();
    const [shareMessage, setShareMessage] = useState('');

    useEffect(async () => {
        if (!showShareModal) {
            // reset to defaults when modal is closed.
            setShareCode();
            setExpirationIndex(0);
            setShareLink('normili.com');
            setIsContentReady(false);
            setSharerName('');
            setSelectionMode(false);
            setStorySelection();
            setShareMessage('');
        }
    }, [showShareModal])

    useEffect(async () => {
        if (!shareCode || !showShareModal) {
            return;
        }

        const expirationValueInDays = ShareExpirationOptions[expirationIndex]?.value;
        const expiresAfter = getExpirationDate(expirationValueInDays);
        await updateShare(shareCode, { expiresAfter });

    }, [expirationIndex])

    useEffect(async () => {
        if (!shareCode || !showShareModal || !storySelection) {
            return;
        }

        await updateShare(shareCode, { storySelection });
    }, [storySelection]) // This is only set once when the user moves on to the next screen after making their selections

    const getExpirationDate = (numDays) => {
        if (numDays) {
            return new Date(Date.now() + numDays * 24 * 60 * 60 * 1000);
        }
        return 'never';
    }

    return (
        <ShareLinkContext.Provider
            value={{
                showShareModal, setShowShareModal, shareLink, setShareLink, isContentReady, setIsContentReady,
                sharerName, setSharerName,
                expirationIndex, setExpirationIndex,
                setShareCode,
                storySelection, setStorySelection,
                shareMessage, setShareMessage,
                isSelectionModeOn, setSelectionMode,
            }}>
            {children}
        </ShareLinkContext.Provider>
    )
}